import { useT } from '@/i18n/I18nProvider'

const COLOR: Record<string, string> = {
  critical: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
  high: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  medium: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-200',
  low: 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200',
}

export function SeverityBadge({ severity }: { severity: string }) {
  const t = useT()
  return (
    <span className={`inline-block px-2 py-0.5 text-xs rounded ${COLOR[severity] ?? COLOR.low}`}>
      {t(`severity.${severity}`)}
    </span>
  )
}
